var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
import { useGenericMonitor } from "./genericTaskMonitor";
const SUCCESS_STATE = "SUCCESS";
const FAILURE_STATE = "FAILURE";
const DEFAULT_POLL_DELAY = 10000;
const DEFAULT_EXPIRATION_TIME = 1000 * 60 * 60 * 24; // 24 hours
/**
 * Composable for waiting on Galaxy background tasks.
 */
export function useTaskMonitor() {
    const fetchStatus = (taskId) => __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().GET("/api/tasks/{task_id}/state", {
            params: { path: { task_id: taskId } },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
    return useGenericMonitor({
        fetchStatus,
        completedCondition: (status) => status === SUCCESS_STATE,
        failedCondition: (status) => status === FAILURE_STATE,
        defaultPollDelay: DEFAULT_POLL_DELAY,
        expirationTime: DEFAULT_EXPIRATION_TIME,
    });
}
